import { schema } from "normalizr";
import { BrandProfile } from "./brand-profile";

export const BrandProfiles = new schema.Array(BrandProfile);
